<template>
  <div>
    <div class="candidate-navbar" style="background-color: #3b425d">
      <button
        v-if="isShowOnBoardData"
        type="button"
        style="background-color: #18c58b; color: #fff"
        @click="gotToPage"
      >
        報到資料
      </button>
      <button
        type="button"
        style="background-color: #18c58b; color: #fff"
        @click="$common.downloadPersonnelInformationPDF(resumeType, matchId)"
      >
        下載 PDF
      </button>
      <a href="javascript:void(0)" @click.prevent="$router.go(-1)">返回</a>
    </div>

    <div class="step-page">
      <h3 class="mb-3 text-center" style="color: #fff">人事資料表</h3>

      <el-tabs
        v-model="activeName"
        :tab-position="windowWidth > 1024 ? 'left' : 'top'"
        class="tab-component"
      >
        <el-tab-pane label="面談背景資料" name="面談背景資料" lazy>
          <div class="step-content no-bg mt-3">
            <WorkedInfo
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="workedInfoKey"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="個人資料" name="個人資料" lazy>
          <div class="step-content no-bg mt-3">
            <div class="step-tip mb-2">
              **
              以下任何欄位皆基於工作所需而請求應徵者提供，若認為涉及個人資料而不願透漏，可選擇不填
            </div>
            <BaseInfo
              ref="baseInfo"
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="baseInfoKey"
              :changePage="changePage"
              :person="person"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="工作條件" name="工作條件" lazy>
          <div class="step-content no-bg mt-3">
            <WorkCondition
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="workConditionKey"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="學歷" name="學歷" lazy>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              ** 僅填寫有拿到畢業證書的最高學歷即可
            </div>
            <Education
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="educationKey"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane label="工作經歷" name="工作經歷" lazy>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              ** 請由最近工作之公司開始填起（有工廠經驗優先填寫）
            </div>
            <WorkExperience
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="workExperienceKey"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane label="專業技能及認證" name="專業技能及認證" lazy>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              ** 請填寫具備的電腦技能、培訓紀錄、證照檢定、工作專長<br />
              <span class="en-text"
                >*Please fill out if you possess computer skills, training
                records, work skill</span
              >
            </div>
            <Skill
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="skillKey"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="自傳" name="自傳" lazy>
          <div class="step-content no-bg">
            <Autobiography
              :source="'personnelInformation'"
              :matchId="matchId"
              :key="autobiographyKey"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import WorkedInfo from "@/components/customize/Front/DL/WorkedInfo";
import BaseInfo from "@/components/customize/Front/DL/BaseInfo";
import WorkCondition from "@/components/customize/Front/DL/WorkCondition";
import Education from "@/components/customize/Front/DL/Education";
import WorkExperience from "@/components/customize/Front/DL/WorkExperience";
import Skill from "@/components/customize/Front/DL/Skill";
import Autobiography from "@/components/customize/Front/DL/Autobiography";

export default {
  name: "DLPersonnelInformation",

  components: {
    WorkedInfo,
    BaseInfo,
    WorkCondition,
    Education,
    WorkExperience,
    Skill,
    Autobiography,
  },

  data() {
    return {
      activeName: "面談背景資料",
      resumeType: "DL",
      matchId: null,
      isShowOnBoardData: false,
      changePage: false,

      workedInfoKey: 0,
      baseInfoKey: 0,
      workConditionKey: 0,
      educationKey: 0,
      workExperienceKey: 0,
      skillKey: 0,
      autobiographyKey: 0,

      windowWidth: 0,
    };
  },

  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    // 轉跳至報到資料
    gotToPage() {
      this.changePage = true;
      this.$refs.baseInfo.saveBaseInfo();
    },
  },

  watch: {
    activeName: function (newVal) {
      switch (newVal) {
        case "面談背景資料":
          this.workedInfoKey += 1;
          break;
        case "個人資料":
          this.baseInfoKey += 1;
          break;
        case "工作條件":
          this.workConditionKey += 1;
          break;
        case "學歷":
          this.educationKey += 1;
          break;
        case "工作經歷":
          this.workExperienceKey += 1;
          break;
        case "專業技能及認證":
          this.skillKey += 1;
          break;
        case "自傳":
          this.autobiographyKey += 1;
          break;
        default:
          this.workedInfoKey += 1;
      }
    },
  },

  created() {
    this.matchId = this.$route.query.matchId;
    this.person = JSON.parse(this.$route.query.personData);
    this.isShowOnBoardData = this.$route.query.isShowOnBoardData ? this.$route.query.isShowOnBoardData.toLowerCase() === "true" : "false";
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
};
</script>

<style lang="scss" scoped>
.step-tip {
  color: #fff;
  font-size: 0.85em;
}

/deep/ .el-tabs__content {
  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-button {
    background: transparent;

    border-radius: 4px;
  }

  &::-webkit-scrollbar-track-piece {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;

    background-color: rgba(0, 0, 0, 0.4);

    border: 1px solid slategrey;
  }

  &::-webkit-scrollbar-track {
    box-shadow: transparent;
  }

  @media screen and (min-width: 768px) {
    height: calc(100vh - 175px);
    overflow: auto;
  }
}

/deep/ .tab-component {
  .el-tabs__item {
    color: #fff;

    &.is-active {
      color: #22c59a;
    }
  }

  .el-tabs__active-bar {
    background-color: #22c59a;
  }

  .important-table {
    width: 90%;
    max-width: 680px;
    margin: 0 auto;

    th {
      color: #fff;
      padding: 10px;
      text-align: center;
    }
    td {
      padding: 10px;
      input,
      select {
        border: none;
        border-radius: 25px;
        width: 100%;
        line-height: 30px;
        height: 30px;
        padding: 0 10px;
      }
    }
  }
}

/deep/ .el-input--prefix .el-input__inner {
  padding-left: 30px !important;
}
</style>
